import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'secondsToHuman'
})
export class SecondsToHumanPipe implements PipeTransform {

  transform(value: number, format: 'short' | 'long' = 'long'): string {
    if (typeof value !== 'number' || isNaN(value) || value < 0) {
      return '';
    }
    const seconds = Math.floor(value);
    if (seconds === 0) {
      return 'Immediate';
    }
    if (seconds < 60) {
      return format === 'short' ? `${seconds}s` : `${seconds} second${seconds !== 1 ? 's' : ''}`;
    } else if (seconds < 3600) {
      const minutes = Math.floor(seconds / 60);
      return format === 'short' ? `${minutes}m` : `${minutes} minute${minutes !== 1 ? 's' : ''}`;
    } else if (seconds < 86400) {
      const hours = Math.floor(seconds / 3600);
      return format === 'short' ? `${hours}h` : `${hours} hour${hours !== 1 ? 's' : ''}`;
    } else {
      const days = Math.floor(seconds / 86400);
      return format === 'short' ? `${days}d` : `${days} day${days !== 1 ? 's' : ''}`;
    }
  }
}
